{
  "title": "Healing Word",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "60 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "A creature of your choice that you can see within range regains hit points equal to 1d4 + your spellcasting ability modifier. This spell has no effect on undead or constructs.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the healing increases by 1d4 for each slot level above 1st."
  ],
  "spellLists": ["bard", "cleric", "druid"]
}
